import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { rootStore } from 'stores/RootStore';
import styles from './supportTicketWidget.module.scss';

export const SupportTicketWidget: React.FC = observer(() => {
  const { SupportTicketStore } = rootStore;

  const handleClick = () => {
    SupportTicketStore.openChat();
  };

  return (
    <>
      <Tooltip target=".support-widget-button" position="left" />
      <div className={styles.widgetContainer}>
        <Button
          icon="pi pi-question-circle"
          rounded
          className={`${styles.widgetButton} support-widget-button`}
          onClick={handleClick}
          data-pr-tooltip="Report an Issue"
          aria-label="Report an Issue"
          severity="help"
        />
      </div>
    </>
  );
});
